import useModal from '@area2k/use-modal';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { format, parseISO } from 'date-fns';

import InvoiceBadge from '../../InvoiceBadge';

import EditInvoiceDetail from './EditInvoiceModal';

import Card from '@/components/Card';
import IconicButton from '@/components/IconicButton';
import Table from '@/components/Table';
import TableHeader from '@/components/TableHeader';
import { TableCell, TableRow } from '@/elements/Table';
import { useGetTimesheetPdfMutation } from '@/graphql';
import { StripeInvoice } from '@/types/graphql';
import { parseTimestamp } from '@/util/date';

type Props = {
  invoice: unknown;
  editable: boolean;
};

const headerFields = ['Date Due', 'Description', 'Invoice Status', 'Timesheet'];

const DetailsCard = ({ invoice, editable }: Props) => {
  const invoiceData = invoice as StripeInvoice;

  const [getTimesheetPdfDetails, { loading }] = useGetTimesheetPdfMutation({
    onCompleted: (data) => {
      const url = data.invoiceTimesheetsPdf.pdfCreated.url;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
  });

  const editableCardAction = editable
    ? [{ a11yLabel: 'Edit', label: 'Edit', onAction: () => showAddModal() }]
    : undefined;

  const [showAddModal, hideAddModal] = useModal(
    () => <EditInvoiceDetail hideModal={hideAddModal} invoice={invoiceData} />,
    [invoiceData]
  );

  const dueDate = parseTimestamp(invoiceData.dueDate);

  return (
    <Card actions={editableCardAction} title="Details">
      <Table>
        <TableHeader fields={headerFields} />
        <tbody>
          <TableRow>
            <TableCell>
              {invoiceData.dueDateDatetime &&
                format(parseISO(dueDate), 'LLLL dd, yyyy')}
            </TableCell>
            <TableCell>{invoiceData.description}</TableCell>
            <TableCell>
              <InvoiceBadge status={invoiceData.status} />
            </TableCell>
            <TableCell>
              <IconicButton
                a11yLabel="action"
                appearance="clear"
                icon={faDownload}
                id="btn-download"
                isLoading={loading}
                size="md"
                onClick={() =>
                  getTimesheetPdfDetails({
                    variables: {
                      invoiceId: invoiceData.id,
                    },
                  })
                }
              />
            </TableCell>
          </TableRow>
        </tbody>
      </Table>
    </Card>
  );
};

export default DetailsCard;
